import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * A reusable editable field component for forms
 * Displays an input in edit mode or formatted text in view mode
 */
export const EditableField = ({ 
  label, 
  value, 
  isEditing, 
  onChange, 
  icon, 
  type = "text", 
  prefix, 
  suffix,
  placeholder,
  className = "",
  testId
}) => {
  if (isEditing) {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        {icon && <span className="text-muted-foreground">{icon}</span>}
        <div className="flex-1">
          <Label className="text-xs text-muted-foreground">{label}</Label>
          <div className="flex items-center gap-1">
            {prefix && <span className="text-sm text-muted-foreground">{prefix}</span>}
            <Input
              type={type}
              value={value || ''}
              onChange={(e) => onChange(e.target.value)}
              className="h-8 text-sm"
              placeholder={placeholder || label}
              data-testid={testId}
            />
            {suffix && <span className="text-sm text-muted-foreground">{suffix}</span>}
          </div>
        </div>
      </div>
    );
  }

  if (!value && value !== 0) return null;

  const formatDisplayValue = () => {
    if (type === 'date' && value) {
      return new Date(value).toLocaleDateString('en-CA', { 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric' 
      });
    }
    let displayValue = prefix ? `${prefix}${value}` : String(value);
    if (suffix) displayValue += suffix;
    return displayValue;
  };

  return (
    <div className={`flex items-center gap-2 text-sm ${className}`}>
      {icon && <span className="text-muted-foreground">{icon}</span>}
      <div>
        <span className="text-xs text-muted-foreground block">{label}</span>
        <span className="text-foreground">{formatDisplayValue()}</span>
      </div>
    </div>
  );
};

export default EditableField;
